/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Check_ChangelogInputs */

const en_directory_agent_readiness_check_changelog = /** @type {(inputs: Directory_Agent_Readiness_Check_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changelog`)
};

const zh_directory_agent_readiness_check_changelog = /** @type {(inputs: Directory_Agent_Readiness_Check_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新日志`)
};

/**
* | output |
* | --- |
* | "Changelog" |
*
* @param {Directory_Agent_Readiness_Check_ChangelogInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_check_changelog = /** @type {((inputs?: Directory_Agent_Readiness_Check_ChangelogInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Check_ChangelogInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_check_changelog(inputs)
	return zh_directory_agent_readiness_check_changelog(inputs)
});
export { directory_agent_readiness_check_changelog as "directory.agent_readiness.check.changelog" }